import { useState } from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { experimentalStyled as styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import UserTypeCard from '../components/UserTypeCard';
import teacherIcon from '../svg/teacherIcon.svg';
import studentIcon from '../svg/studentIcon.svg';
import TeacherForm from '../components/registrationForms/TeacherForm';
import StudentForm from '../components/registrationForms/StudentForm';
import SchoolForm from '../components/registrationForms/SchoolForm';
import InstituteForm from '../components/registrationForms/InstituteForm';
import Page from '../components/Page';
import BackgroundImage from '../svg/FainlearnBackSvg.svg';
import Iconify from '../fl-components/Iconify';
import { delAllCke } from '../helper/cookieHelper';
import { REMOVE_ORG, USER_LOGIN } from '../redux/constants';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const useStyles = makeStyles({
  wrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',

    // '@media (min-width:600px)': {
    //   height: '100vh'
    // },

    '@media (max-width: 920px)': {
      padding: '0 20px'
    }
  },
  wrapperCard: {
    width: '1000px',
    borderRadius: '8px'
  },
  button: {
    width: '100%',
    fontSize: '16px',
    padding: '10px 0',
    borderRadius: '100px'
  }
});

export default function PickUserType() {
  const auth = getAuth();
  const [userType, setUserType] = useState('');
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const backToLogin = () => {
    const obj = {
      currentUser: null,
      isLogin: false,
      loading: false
    };
    dispatch({ type: USER_LOGIN, response: obj });
    dispatch({ type: REMOVE_ORG });
    if (auth.currentUser) auth.signOut();
    localStorage.clear();
    navigate('/login', { replace: true });
    delAllCke();
  };

  // == User Type Form Card ==
  const formUserType = (
    <RootStyle
      title="Fainlearn | Select User"
      isDivRender={false}
      style={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: 'cover'
      }}
    >
      <Box className={classes.wrapper}>
        <Box className={classes.wrapperCard}>
          <Box>
            <IconButton
              sx={{ position: 'absolute', top: 15, right: 15 }}
              color="secondary"
              onClick={() => backToLogin()}
            >
              <Iconify icon="bx:log-out" width={25} height={25} />
            </IconButton>
            <Typography variant="h4" sx={{ marginBottom: '15px', textAlign: 'center' }}>
              You want to login as
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} md={3}>
                <UserTypeCard
                  title="Teacher"
                  icon={teacherIcon}
                  selected={userType}
                  handleClick={setUserType}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <UserTypeCard
                  title="Student"
                  icon={studentIcon}
                  selected={userType}
                  handleClick={setUserType}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <UserTypeCard
                  title="School"
                  icon={teacherIcon}
                  selected={userType}
                  handleClick={setUserType}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <UserTypeCard
                  title="Institute"
                  icon={studentIcon}
                  selected={userType}
                  handleClick={setUserType}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </RootStyle>
  );

  // == Teacher Form ==
  const formTeacher = <TeacherForm handleBack={() => setUserType('')} />;

  // == Student Form ==
  const formStudent = <StudentForm handleBack={() => setUserType('')} />;

  // == School Form ==
  const formSchool = <SchoolForm handleBack={() => setUserType('')} />;

  // == Institute / College Form ==
  const formInstituteCollege = <InstituteForm handleBack={() => setUserType('')} />;

  // == Handle which form to render ==
  let componentToRender;
  if (!userType) {
    componentToRender = formUserType;
  } else if (userType === 'Teacher') {
    componentToRender = formTeacher;
  } else if (userType === 'Student') {
    componentToRender = formStudent;
  } else if (userType === 'School') {
    componentToRender = formSchool;
  } else if (userType === 'Institute') {
    componentToRender = formInstituteCollege;
  }

  return componentToRender;
}
